<template>
    <div :class="['admin-stepper', sizeClass]" :dusk="dusk">
        <Button
            type="button"
            color="default"
            variant="inline"
            :size="size"
            :disabled="disabled || atMin"
            @click="decrement"
        >
            <Icon icon="phosphor/regular/minus" class="size-3.5" />
        </Button>
        <span class="admin-stepper__value">{{ displayValue }}</span>
        <Button
            type="button"
            color="default"
            variant="inline"
            :size="size"
            :disabled="disabled || atMax"
            @click="increment"
        >
            <Icon icon="phosphor/regular/plus" class="size-3.5" />
        </Button>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Button from '@src/Common/Components/Button.vue';
import type { FieldComponent } from '@src/Common/Components/types';

const modelValue = defineModel<number>({ default: 0 });

const props = withDefaults(defineProps<FieldComponent>(), {
    size: 'base',
    disabled: false,
});

const minValue = computed<number>(() => Number(props.field?.min ?? 0));

const maxValue = computed<number>(() => {
    const raw = props.field?.max;
    return raw === undefined || raw === null ? Number.POSITIVE_INFINITY : Number(raw);
});

const stepValue = computed<number>(() => Number(props.field?.step ?? 1));

const displayValue = computed<number>(() => modelValue.value ?? minValue.value);

const atMin = computed<boolean>(() => displayValue.value <= minValue.value);

const atMax = computed<boolean>(() => displayValue.value >= maxValue.value);

const sizeClass = computed<string>(() => `admin-stepper--${props.size}`);

const clamp = (n: number): number => Math.min(maxValue.value, Math.max(minValue.value, n));

const increment = (): void => {
    modelValue.value = clamp(displayValue.value + stepValue.value);
};

const decrement = (): void => {
    modelValue.value = clamp(displayValue.value - stepValue.value);
};
</script>
